import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Pagination from "../../../shared/ReusuableComponent/Pagination/Pagination";
import { AxiosInstance } from "../../../../src/axios/index";
import styles from "./Rbac.module.css";
import { Chip, Paper } from "@mui/material";
import Loader from "../../../shared/Component/Loader";

const RoleList = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { filter_emptype, filter_location, filter_search } =
    location.state || {};
  const [updateListData, setUpdateListData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [sortOrder, setSortOrder] = useState("asc");
  const [sortColumn, setSortColumn] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const empTypeList = [
    { id: 0, name: "Faculty" },
    { id: 1, name: "Staff" },
    { id: 3, name: "Panel Member" },
  ];
  const [locationList, setLocationList] = useState([]);
  const [isOpen, setIsOpen] = useState({
    emp_type: false,
    location: false,
  });
  const [selectedEmpTypes, setSelectedEmpTypes] = useState([]);
  const [tempSelectedLocation, setTempSelectedLocation] = useState("");
  const [selectedLocationId, setSelectedLocationId] = useState([]);
  const [updateChipData, setUpdateChipData] = useState([]);

  const [searchTerm, setSearchTerm] = useState("");
  const txtBSearch = useRef(null);
  const filterRefEmpType = useRef();
  const filterRefLocation = useRef();
  //  Fetch data
  useEffect(() => {
    if (location.state) {
      // Optionally do something here if needed
    }
  }, [location.state]);

  useEffect(() => {
    if (location.state) {
      navigate(location.pathname, {
        replace: true,
        state: {},
      });
    }
  }, []);

  useEffect(() => {
    // Scroll to the top of the page when the component mounts
    window.scrollTo(0, 0);
  }, []);

  function loadListData() {
    let tempEmepType = [];
    let tempEmpLoc = [];
    selectedEmpTypes.map((obj) => {
      tempEmepType.push(obj.id);
    });
    selectedLocationId.map((obj) => {
      tempEmpLoc.push(obj.id);
    });

    let statusFilter = {
      search: searchTerm.length > 0 ? searchTerm : "",
      emp_type: selectedEmpTypes.length > 0 ? tempEmepType : "",
      location_id: selectedLocationId.length > 0 ? tempEmpLoc : "",
      title: "",
    };
    setIsLoading(true);
    AxiosInstance.post("/api/menu/list", statusFilter)
      .then((res) => {
        if (res.data.status) {
          setIsLoading(false);
          const fiata = res.data.data;
          setCurrentPage(1);
          const serialNumberAddedData = fiata.map((data, index) => ({
            ...data,
            serialNumber: index + 1,
          }));

          // Set CSV data
          setUpdateListData(serialNumberAddedData);
          const uniqueLocations = [
            ...new Map(
              fiata
                .filter((d) => d.location_id && d.location)
                .map((d) => [
                  d.location_id,
                  { id: d.location_id, name: d.location },
                ])
            ).values(),
          ];
          setLocationList(uniqueLocations);
        } else if (res.data.status === false) {
          setUpdateListData([]);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setUpdateListData([]);
        setIsLoading(false);
        return error;
      });
  }
  useEffect(() => {
    setUpdateListData(updateListData);
  }, [updateListData]);
  // Initial load
  const [isFiltersInitialized, setIsFiltersInitialized] = useState(false);

  useEffect(() => {
    if (filter_emptype && filter_emptype.length > 0) {
      setSelectedEmpTypes(filter_emptype);
      filterEmpType = filter_emptype;
    } else {
      setSelectedEmpTypes(selectedEmpTypes);
      filterEmpType = selectedEmpTypes;
    }
    if (filter_location && filter_location.length > 0) {
      setSelectedLocationId(filter_location);
      filterLoaction = filter_location;
    } else {
      setSelectedLocationId(selectedLocationId);
      filterLoaction = selectedLocationId;
    }
    if (filter_search && filter_search.length > 0) {
      filterSearch = [{ name: "" + filter_search, type: "search" }];
      setSearchTerm(filter_search);
    } else {
      if (searchTerm) {
        // setSearchTerm(status);
        filterSearch = [{ name: "" + searchTerm, type: "search" }];
      }
    }
    setIsFiltersInitialized(true);
    loadChipdata();
  }, []);

  useEffect(() => {
    if (isFiltersInitialized && filter_emptype && filter_emptype.length > 0) {
      loadListData();
    } else if (
      isFiltersInitialized &&
      filter_location &&
      filter_location.length > 0
    ) {
      loadListData();
    }
  }, [
    selectedEmpTypes,
    selectedLocationId,
    filter_search,
    isFiltersInitialized,
    updateChipData,
  ]);
  useEffect(() => {
    if (isFiltersInitialized) {
      loadListData();
    }
  }, [isFiltersInitialized, updateChipData]);

  const start = (currentPage - 1) * rowsPerPage;
  const end = start + rowsPerPage;
  const currentData = updateListData.slice(start, end);
  const totalPages = Math.ceil(updateListData.length / rowsPerPage);

  const handleSort = (e, sortKey) => {
    e.preventDefault();
    // If same column clicked again, toggle order. Otherwise, start fresh as 'asc'.
    const newOrder =
      sortColumn === sortKey ? (sortOrder === "asc" ? "desc" : "asc") : "asc";
    setSortOrder(newOrder);
    setSortColumn(sortKey);
    let sortedList = [...updateListData];
    if (sortKey === "serialNumber") {
      // Sort numerically by serial number (always re-sorts fresh)
      sortedList =
        newOrder === "asc"
          ? [...updateListData].sort((a, b) => a.serialNumber - b.serialNumber)
          : [...updateListData].sort((a, b) => b.serialNumber - a.serialNumber);
    } else {
      // Normal alphabetical/numeric sorting
      sortedList.sort((a, b) => {
        const aValue = a[sortKey] ? a[sortKey].toString().toLowerCase() : "";
        const bValue = b[sortKey] ? b[sortKey].toString().toLowerCase() : "";
        if (aValue < bValue) return newOrder === "asc" ? -1 : 1;
        if (aValue > bValue) return newOrder === "asc" ? 1 : -1;
        return 0;
      });
      // After sorting any other column, reassign serial numbers
      sortedList = sortedList.map((item, index) => ({
        ...item,
        serialNumber: index + 1,
      }));
    }
    setUpdateListData(sortedList);
  };

  const handlePageCount = (e) => {
    setRowsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };
  //  Handle checkbox selection
  const handleCheckboxChange = (e, type) => {
    const { name, value, checked } = e.target;
    if (type === "emp_type") {
      if (checked) {
        setSelectedEmpTypes([
          ...selectedEmpTypes,
          { id: value, name: name, type: "emp_type" },
        ]);
      } else {
        setSelectedEmpTypes(
          selectedEmpTypes.filter((item) => item.id !== value)
        );
      }
    }
    if (type === "location") {
      if (checked) {
        setSelectedLocationId([{ id: value, name: name, type: "location" }]);
      } else {
        setSelectedLocationId(
          selectedLocationId.filter((item) => item.id !== value)
        );
      }
    }
  };

  let filterEmpType = [];
  let filterLoaction = [];
  let filterSearch = [];
  useEffect(() => {
    filterEmpType = selectedEmpTypes;
  }, [selectedEmpTypes]);
  useEffect(() => {
    filterLoaction = selectedLocationId;
  }, [selectedLocationId]);

  function loadChipdata() {
    let tempArr = [];

    filterSearch.map((obj) => {
      tempArr.push(obj);
    });
    filterEmpType.map((obj) => {
      tempArr.push(obj);
    });
    filterLoaction.map((obj) => {
      tempArr.push(obj);
    });
    setUpdateChipData(tempArr);
  }

  function updateStateData() {
    filterEmpType = selectedEmpTypes;
    filterLoaction = selectedLocationId;
    if (searchTerm.length > 0) {
      filterSearch = [{ name: "" + searchTerm, type: "search" }];
    } else {
      filterSearch = [];
    }
  }
  //  Apply Filter
  const handleApplyFilter = (type) => {
    updateStateData();
    if (type === "emp_type") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        emp_type: false,
      });
    }
    if (type === "location") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        location: false,
      });
    }
  };
  const handleClearFilter = (type) => {
    updateStateData();

    if (type === "emp_type") {
      setSelectedEmpTypes([]);
      filterEmpType = [];
      setIsOpen((prev) => ({
        ...prev,
        emp_type: false,
      }));
    } else if (type === "location") {
      setSelectedLocationId([]);
      filterLoaction = [];
      setIsOpen((prev) => ({
        ...prev,
        location: false,
      }));
    }
    setTimeout(() => {
      loadChipdata();
    }, 200);
    loadListData();
  };

  //  Search Handlers
  const handleSearch = (event) => {
    if (event.key === "Enter") {
      let val = event.target.value;
      updateStateData();
      setSearchTerm(val);
      if (val.length > 0) {
        filterSearch = [{ name: "" + val, type: "search" }];
      } else {
        filterSearch = [];
      }
      loadChipdata();
    }
  };
  const handleSearchFocus = () => {
    if (txtBSearch.current) {
      txtBSearch.current.focus();
      const event = new KeyboardEvent("keydown", {
        key: "Enter",
        keyCode: 13,
        which: 13,
        code: "Enter",
        bubbles: true,
      });
      txtBSearch.current.dispatchEvent(event);
    }
  };

  const handleDelete = (chipToDelete) => () => {
    let updatedChips = updateChipData.filter(
      (chip) =>
        chip.type !== chipToDelete.type || chip.name !== chipToDelete.name
    );

    if (chipToDelete.type === "search") {
      setSearchTerm("");
      filterSearch = [];
    } else if (chipToDelete.type === "emp_type") {
      const updatedEmpTypes = selectedEmpTypes.filter(
        (item) => item.id !== chipToDelete.id
      );
      setSelectedEmpTypes(updatedEmpTypes);
      filterEmpType = updatedEmpTypes;
    } else if (chipToDelete.type === "location") {
      const updatedLocations = selectedLocationId.filter(
        (item) => item.id !== chipToDelete.id
      );
      setSelectedLocationId(updatedLocations);
      filterLoaction = updatedLocations;
    }

    setUpdateChipData(updatedChips);
  };

  const handleAllClear = () => {
    setSearchTerm([]);
    setSelectedEmpTypes([]);
    setSelectedLocationId([]);
    setTempSelectedLocation("");
    setUpdateChipData([]);
    loadListData();
  };
  // Outside click detection
  useEffect(() => {
    const handleClickOutside = (event) => {
      const isCheckbox = event.target.closest('input[type="checkbox"]');
      const isApplyFilterButton = event.target.closest(".filterBoxs_testlist");
      const isChipData = event.target.closest(".paperil_global");
      if (isCheckbox || isApplyFilterButton || isChipData) return;
      // ===== EMP TYPE FILTER =====
      if (
        filterRefEmpType.current &&
        !filterRefEmpType.current.contains(event.target)
      ) {
        const hasEmpType = updateChipData.some(
          (chipItem) => chipItem.type === "emp_type"
        );

        if (hasEmpType) {
          const updatedEmpType = updateChipData.filter(
            (chipItem) => chipItem.type === "emp_type"
          );
          setSelectedEmpTypes(updatedEmpType); // restore from chips
        } else {
          setSelectedEmpTypes([]); // reset if not found
        }

        setIsOpen((prev) => ({ ...prev, emp_type: false }));
      }
      // ===== LOCATION FILTER =====
      if (
        filterRefLocation.current &&
        !filterRefLocation.current.contains(event.target)
      ) {
        const hasLocation = updateChipData.some(
          (chipItem) => chipItem.type === "location"
        );

        if (hasLocation) {
          const updatedLocation = updateChipData.filter(
            (chipItem) => chipItem.type === "location"
          );
          setSelectedLocationId(updatedLocation);
        } else {
          setSelectedLocationId([]);
        }
        setIsOpen((prev) => ({ ...prev, location: false }));
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [updateChipData, selectedEmpTypes, selectedLocationId]);

  const handleReadView = (item) => {
    navigate(`/MenuList/${item.user_id}`, {
      state: {
        selectedRole: item,
        EmpType: selectedEmpTypes,
        Location: selectedLocationId,
        Search: searchTerm,
      },
    });
  };
  return isLoading ? (
    <div
      className="loaderApi"
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "white",
        zIndex: 999,
      }}
    >
      <Loader />
    </div>
  ) : (
    <div className="container-fluid global_container p-0">
      <div className={`${styles.cm_container} BathHeader`}>
        <div className="row">
          <div className="col-md-6 col-12">
            <h2 className="TitleHeader">Page Access</h2>
          </div>
        </div>
        {/* Search Bar */}
        <div className="row mt-3">
          <div className="col-lg-4 col-md-4 col-sm-12 mb-2">
            <div className="input-group">
              <input
                ref={txtBSearch}
                type="text"
                className={styles.Inputs}
                placeholder="Search by Employee_Id, Name, Title, Email, Phone Number"
                onKeyDown={handleSearch}
              />
              <span
                className={styles.input_group_text}
                onClick={handleSearchFocus}
              >
                <span className="material-icons">search</span>
              </span>
            </div>
          </div>
        </div>
        {/*  Chips Display */}
        {updateChipData.length > 0 && (
          <div className="row mt-3">
            <div className="col-md-12">
              <Paper
                component="ul"
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  listStyle: "none",
                  boxShadow: "none",
                  p: 0.5,
                  m: 0,
                  alignItems: "center", // Align all items in a row
                }}
              >
                {updateChipData.map((data, index) => (
                  <li
                    key={index}
                    style={{
                      margin: "0 5px 5px 0",
                      display: "inline-flex",
                    }}
                  >
                    <Chip label={data.name} onDelete={handleDelete(data)} />
                  </li>
                ))}
                <li
                  style={{
                    margin: "0 5px 5px 0",
                    display: "inline-flex",
                    cursor: "pointer",
                  }}
                >
                  <a className="clearAll_listItem" onClick={handleAllClear}>
                    Clear All Filters
                  </a>
                </li>
              </Paper>
            </div>
          </div>
        )}
        {/*  Table Section */}
        <div className="row mt-2 p-2">
          <div className="col-md-12 table-responsive tableMinHeight p-0">
            <table className="table" id="tableListHeader">
              <thead>
                <tr>
                  {/* S.No */}
                  <th id="th">
                    <span
                      className="textHead_th"
                      onClick={(e) => handleSort(e, "serialNumber")}
                    >
                      S.No
                    </span>
                    <span
                      className="textHead_th material-icons align-middle"
                      onClick={(e) => handleSort(e, "serialNumber")}
                    >
                      import_export
                    </span>
                  </th>
                  {/* faculty_id */}
                  <th id="th">
                    <span
                      className="textHead_th"
                      onClick={(e) => handleSort(e, "faculty_id")}
                    >
                      Employee_ID
                    </span>
                    <span
                      className="textHead_th material-icons align-middle"
                      onClick={(e) => handleSort(e, "faculty_id")}
                    >
                      import_export
                    </span>
                  </th>
                  {/* Name */}
                  <th id="th">
                    <span
                      className="textHead_th"
                      onClick={(e) => handleSort(e, "fullname")}
                    >
                      Name
                    </span>
                    <span
                      className="textHead_th material-icons align-middle"
                      onClick={(e) => handleSort(e, "fullname")}
                    >
                      import_export
                    </span>
                  </th>
                  {/* Title */}
                  <th id="th">
                    <span
                      className="textHead_th"
                      onClick={(e) => handleSort(e, "title")}
                    >
                      Title
                    </span>
                    <span
                      className="textHead_th material-icons align-middle"
                      onClick={(e) => handleSort(e, "title")}
                    >
                      import_export
                    </span>
                  </th>
                  {/* Email */}
                  <th id="th">
                    <span
                      className="textHead_th"
                      onClick={(e) => handleSort(e, "email")}
                    >
                      Email
                    </span>
                    <span
                      className="textHead_th material-icons align-middle"
                      onClick={(e) => handleSort(e, "email")}
                    >
                      import_export
                    </span>
                  </th>
                  {/* Mobile Number */}
                  <th id="th">
                    <span
                      className="textHead_th"
                      onClick={(e) => handleSort(e, "mobile_no")}
                    >
                      Phone Number
                    </span>
                    <span
                      className="textHead_th material-icons align-middle"
                      onClick={(e) => handleSort(e, "mobile_no")}
                    >
                      import_export
                    </span>
                  </th>
                  {/* Employee Type Filter */}
                  <th id="th" ref={filterRefEmpType}>
                    <span
                      className="textHead_th"
                      onClick={(e) => handleSort(e, "emp_type")}
                    >
                      Employee Type
                    </span>
                    <span
                      className="textHead_th material-icons align-middle"
                      onClick={(e) => handleSort(e, "emp_type")}
                    >
                      import_export
                    </span>
                    <span
                      className={`textHead_th align-middle material-icons ${
                        selectedEmpTypes.length > 0 || isOpen.emp_type
                          ? styles.active_icons_book
                          : ""
                      }`}
                      onClick={() =>
                        setIsOpen((prev) => ({
                          ...prev,
                          emp_type: !prev.emp_type,
                        }))
                      }
                    >
                      filter_list
                    </span>

                    {isOpen.emp_type && (
                      <div className="filterBoxs_testlist mt-3">
                        <ul className="ulFilterListData">
                          {empTypeList.map((el) => (
                            <li className="filterListData" key={el.id}>
                              <input
                                className="ListCheckbox"
                                type="checkbox"
                                name={el.name}
                                value={el.id}
                                id={el.name}
                                // checked={selectedEmpTypes.includes(el.id)}

                                checked={selectedEmpTypes.some((element) => {
                                  if (element.id == el.id) {
                                    return true;
                                  }
                                })}
                                onChange={(e) =>
                                  handleCheckboxChange(e, "emp_type")
                                }
                              />
                              <label
                                className="form-check-label filterChipText_withoutBG"
                                htmlFor={el.name}
                              >
                                {el.name}
                              </label>
                            </li>
                          ))}
                        </ul>
                        <div className="borderWidth row">
                          <ul className="List-Button">
                            <li className="ListBtnItems">
                              <Link
                                to={"#"}
                                onClick={() => handleClearFilter("emp_type")}
                                className="secondaryButton"
                              >
                                Clear
                              </Link>
                            </li>
                            <li className="ListBtnItems">
                              <Link
                                to={"#"}
                                onClick={() => handleApplyFilter("emp_type")}
                                className="primaryButton"
                              >
                                Apply Filter
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    )}
                  </th>
                  {/* Location Filter */}
                  <th id="th" ref={filterRefLocation}>
                    <span
                      className="textHead_th"
                      onClick={(e) => handleSort(e, "location")}
                    >
                      Location
                    </span>
                    <span
                      className="textHead_th material-icons align-middle"
                      onClick={(e) => handleSort(e, "location")}
                    >
                      import_export
                    </span>
                    <span
                      className={`textHead_th align-middle material-icons ${
                        selectedLocationId.length > 0 || isOpen.location
                          ? styles.active_icons_book
                          : ""
                      }`}
                      onClick={() =>
                        setIsOpen((prev) => ({
                          ...prev,
                          location: !prev.location,
                        }))
                      }
                    >
                      filter_list
                    </span>

                    {isOpen.location && (
                      <div className="filterBoxs_testlist mt-3">
                        <ul className="ulFilterListData">
                          {locationList.map((el) => (
                            <li className="filterListData" key={el.id}>
                              <input
                                className="ListCheckbox"
                                type="checkbox"
                                name={el.name}
                                value={el.id}
                                id={el.name}
                                checked={selectedLocationId.some((element) => {
                                  if (element.id == el.id) {
                                    return true;
                                  }
                                })}
                                onChange={(e) =>
                                  handleCheckboxChange(e, "location")
                                }
                              />
                              <label
                                className="form-check-label filterChipText_withoutBG"
                                htmlFor={el.name}
                              >
                                {el.name}
                              </label>
                            </li>
                          ))}
                        </ul>
                        <div className="borderWidth row">
                          <ul className="List-Button">
                            <li className="ListBtnItems">
                              <Link
                                to={"#"}
                                onClick={() => handleClearFilter("location")}
                                className="secondaryButton"
                              >
                                Clear
                              </Link>
                            </li>
                            <li className="ListBtnItems">
                              <Link
                                to={"#"}
                                disabled={!tempSelectedLocation}
                                onClick={() => handleApplyFilter("location")}
                                className="primaryButton"
                              >
                                Apply Filter
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    )}
                  </th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                {currentData.length > 0 ? (
                  currentData.map((item, index) => (
                    <tr key={item.id || `${item.user_id}-${index}`}>
                      <td>{item.serialNumber}</td>
                      <td>{item.faculty_id || "-"}</td>
                      <td>{item.fullname || "-"}</td>
                      <td>{item.title || "-"}</td>
                      <td>{item.email || "-"}</td>
                      <td>{item.mobile_no || "-"}</td>
                      <td>{item.emp_type || "-"}</td>
                      <td>{item.location || "-"}</td>

                      <td>
                        <button
                          className="view_icon_button"
                          onClick={() => handleReadView(item)}
                        >
                          <span className="visibleicon material-icons">
                            visibility
                          </span>
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="9" className="text-center">
                      No data available
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
        {/* Pagination */}
        <div className="row mt-2 mb-5">
          <Pagination
            rowsPerPage={rowsPerPage}
            handlePageCount={handlePageCount}
            startPage={updateListData.length > 0 ? start + 1 : 0}
            endPage={
              updateListData.length > 0
                ? Math.min(end, updateListData.length)
                : 0
            }
            totalRecords={updateListData.length || 0}
            handlePrev={() => setCurrentPage(currentPage - 1)}
            currentPrevPage={currentPage === 1}
            prevButton={`${styles.prev_buttonViewEvaluator} ${styles.materialIconsRightAndLeft} me-2`}
            handleNext={() => setCurrentPage(currentPage + 1)}
            currentNextPage={currentPage === totalPages}
          />
        </div>
      </div>
    </div>
  );
};

export default RoleList;
